import { useUserStore } from "/@/store/modules/user";



const getConfig =(flag, isManage) => {
  const userStore = useUserStore();
  if (isManage) {
    return userStore.getUserConfig?.configInfo?.manageUserDesensitizeFlag?.[flag] ?? false
  }
  return userStore.getUserConfig?.configInfo?.globalDesensitizeFlag?.[flag] ?? false
}

const getDesensitizeNum = (num) => {
  let text = '*'
  if (num > 0) {
    text = new Array(num).fill('*').join('')
  }
  return text
}

const desensitize = {
  
  /**
   * 姓名脱敏
   * @param v 值 
   * @param config  
   * config {
   *   flag 是否根据 nameDesensitizeFlag 的值脱敏， 不根据则为脱敏
   *   isManage 是否为系统脱敏
   * }
   */
  desensitizeName: (v: string, config: {isManage?: boolean, flag?: boolean} = {}) => {
    let text = v;
    const desensitizeFlag = getConfig('nameDesensitizeFlag', !!config?.isManage)
    if (v && (config?.flag || desensitizeFlag)) {
      text = desensitizeMap.text(v)
    } 
    // console.log(v, 'nameDesensitizeFlag---', text)
    return text
  },
  /**
   * 电话脱敏
   * @param v 值
   * @param config  
   * config {
   *   flag 是否根据 phoneDesensitizeFlag 的值脱敏， 不根据则为脱敏
   *   isManage 是否为系统脱敏
   * }
   */
  desensitizePhone: (v: string, config: {isManage?: boolean, flag?: boolean} = {}) => {
    let text = v;
    const desensitizeFlag = getConfig('phoneDesensitizeFlag', !!config?.isManage)
    if (v && (config?.flag || desensitizeFlag)) {
      text = desensitizeMap.mobilePhone(v)
    }
    // console.log(v, 'phoneDesensitizeFlag---', text)
    return text
  },
  /**
   * 邮箱脱敏
   * @param v 值
   * @param config  
   * config {
   *   flag 是否根据 mailDesensitizeFlag 的值脱敏， 不根据则为脱敏
   *   isManage 是否为系统脱敏
   * }
   */
  desensitizeMail: (v: string, config: {isManage?: boolean, flag?: boolean} = {}) => {
    let text = v;
    const desensitizeFlag = getConfig('mailDesensitizeFlag', !!config?.isManage)
    if (v && (config?.flag || desensitizeFlag)) {
      text = desensitizeMap.mail(v)
    }
    // console.log(v, 'mailDesensitizeFlag---', text)
    return text
  },
  /**
   * 身份证脱敏
   * @param v 值
   * @param config  
   * config {
   *   flag 是否根据 idCardDesensitizeFlag 的值脱敏， 不根据则为脱敏
   *   isManage 是否为系统脱敏
   * }
   */
  desensitizeIdCard: (v: string, config: {isManage?: boolean, flag?: boolean} = {}) => {
    let text = v;
    const desensitizeFlag = getConfig('idCardDesensitizeFlag', !!config?.isManage)
    if (v && (config?.flag || desensitizeFlag)) {
      text = desensitizeMap.idCard(v)
    }
    // console.log(v, 'idCardDesensitizeFlag---', text)
    return text
  },
  /**
   * 银行卡脱敏
   * @param v 值
   * @param config  
   * config {
   *   flag 是否根据 bankNoDesensitizeFlag 的值脱敏， 不根据则为脱敏
   *   isManage 是否为系统脱敏
   * }
   */
  desensitizeBank: (v: string, config: {isManage?: boolean, flag?: boolean} = {}) => {
    let text = v;
    const desensitizeFlag = getConfig('bankNoDesensitizeFlag', !!config?.isManage)
    if (v && (config?.flag || desensitizeFlag)) {
      text = v.replace(/.*(.{4})/,`${ getDesensitizeNum(4) }$1`)
    }
    // console.log(v, 'bankNoDesensitizeFlag---', text)
    return text
  },
}

const desensitizeMap = {
  idCard(v: string) {
    if (typeof v !== 'string' || !v.length) {
      return v
    }
    return v.replace(/(.{3}).+(.{6})/,`$1${ getDesensitizeNum(v.length-9) }$2`)
  },
  mail(v: string) {
    if (typeof v !== 'string' || !v.length) {
      return v
    }
    const index = v.indexOf('@')
    if (index > 2) {
      const startStr = v.substring(0, index)
      const endStr = v.substring(index, v.length)
      return startStr.replace(/^(.).+(.)/, `$1${ getDesensitizeNum(startStr.length-2) }$2`) + endStr
    }
    return v
  },
  mobilePhone(v: string) {
    if (typeof v !== 'string' || !v.length) {
      return v
    }
    return v.replace(/(.{3}).+(.{4})/,`$1${ getDesensitizeNum(v.length-7) }$2`)
  },
  fixedPhone(v: string) {
    if (typeof v !== 'string' || !v.length) {
      return v
    }
    return v.replace(/.+(.{4})/,`${ getDesensitizeNum(v.length-4) }$1`)
  },
  text(v: string) {
    if (typeof v !== 'string' || !v.length) {
      return v
    }
    if (v?.length > 2) {
      return v.replace(/^(.).+(.)/, `$1${ getDesensitizeNum(v.length-2) }$2`)
    }
    return v.replace(/^(.).+/,"$1*") ?? '';
  },
}

export { desensitize, desensitizeMap };
